import React from 'react';
import Reflux from 'reflux';
import {hashHistory, withRouter} from 'react-router';
import {Button, message, Modal, Form, Input} from 'antd';
import {DmsTab, TableView, FilterBox} from 'Components';
import {fetchList, submitFeedback, feedBacklist, updateFeedback} from '../../service/survey';
import moment from 'moment';
import {openNotice} from 'Utils';


const FormItem = Form.Item;

class SurveyList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['合作伙伴心声'],
            button_limits_end: JSON.parse(window.localStorage.getItem('button_limits_end')),
            rows: [],
            total: 0,
            filterBoxVisible: false,
            searchObj: {
                title: '',
                createdDate: '',
                isExpire: '',
                p: 1,
                s: 10
            },
            searchObj2: {
                title: '',
                createdDate: '',
                p: 1,
                s: 10
            },
            loading: true,
            rows2: [],
            total2: 0,
            loading2: true
        };

        this.pageChange = this.pageChange.bind(this);
        this.pageChange2 = this.pageChange2.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getData();
        this.getData2();
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    //请求数据
    getData = () => {
        fetchList(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        })
    }

    getData2 = () => {
        feedBacklist(this.state.searchObj2).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows2: result.data,
                    total2: result.total,
                    loading2: false
                })
            } else {
                message.error(result.message);
                this.setState({loading2: false});
            }
        })
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    visibleChange = () => {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceSubmit = (form) => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            },
            loading: true
        }, function () {
            this.getData();
        });

    };

    advanceReset = () => {
        this.setState({
            filterBoxVisible: !this.state.filterBoxVisible,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, () => {
            this.getData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    };

    pageChange = (page, pageSize) => {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            this.getData();
        });
    }

    pageChange2 = (page, pageSize) => {
        this.setState({searchObj2: {...this.state.searchObj2, s: pageSize, p: page}, loading2: true}, function () {
            this.getData2();
        });
    }

    showModal = () => {
        this.setState({visible: true});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }
    handleCreate = () => {
        const form = this.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            submitFeedback(values).then((result) => {
                if (result && result.code == 200) {
                    openNotice('success', '提交成功', '');
                    this.getData2();
                }
            });

            form.resetFields();
            this.setState({visible: false});
        });
    }
    saveFormRef = (form) => {
        this.form = form;
    }

    edit(record) {
        const {rows2} = this.state;
        rows2.forEach(item => {
            if (item.id === record.id) {
                item.edit = true;
            }
        })
        this.setState({
            rows2: this.state.rows2
        });
    }

    save(record) {
        const {rows2} = this.state;

        updateFeedback(record).then(res => {
            if (res.code === 200) {
                openNotice('success', '修改成功', '');
                rows2.forEach(item => {
                    if (item.id === record.id) {
                        item.edit = false;
                    }
                });
                this.setState({
                    rows2: this.state.rows2
                })
            }
        })
    }

    changeInput(e, record, type) {
        const {rows2} = this.state;
        rows2.forEach(item => {
            if (item.id === record.id) {
                item[type] = e.target.value;
            }
        });
        this.setState({
            rows2: this.state.rows2,
        });
    }

    render() {
        const {
            opts,
            filterBoxVisible,
            rows,
            rows2,
            total,
            total2,
            searchObj,
            searchObj2,
            button_limits_end,
            loading,
            loading2
        } = this.state;

        // 筛选弹窗
        const filterBoxProps = {
            showFlag: filterBoxVisible,
            advance: {
                fileds: [
                    {
                        name: 'title',
                        label: '调研主题',
                        defaultValue: searchObj.title,
                        text: '调研主题',
                        type: 'default'
                    },
                    {
                        name: 'createdDate',
                        label: '发布日期',
                        options: [
                            {text: '这个日期之前'},
                            {text: '这个日期之后'},
                            {text: '当前日期'}
                        ],
                        type: 'dateComp'
                    },
                    {
                        name: 'isExpire',
                        label: '是否过期',
                        defaultValue: '',
                        options: [
                            {value: '0', text: '全部'},
                            {value: '1', text: '是'},
                            {value: '2', text: '否'}
                        ],
                        text: '选择是否过期',
                        multiple: false,
                        type: 'select'
                    }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            }
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: this.state.searchObj.p,//当前页码
                pageSize: this.state.searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '调研主题',
                    dataIndex: 'title',
                    render: (text, record) => <a href={`#/survey/${record.id}`}>{text}</a>
                },
                {
                    title: '发布人',
                    dataIndex: 'createdUserName'
                },
                {
                    title: '发布时间',
                    dataIndex: 'createdDate',
                    render: (text, record) => {
                        return moment(Number(text)).format('YYYY-MM-DD HH:mm:ss')
                    }
                },
                {
                    title: '参与评测数',
                    dataIndex: 'joinCount'
                }
            ],
            rows
        };

        const tableViewProps2 = {
            loading: loading2,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total2,
                current: this.state.searchObj2.p,//当前页码
                pageSize: this.state.searchObj2.s,//当前分页数
                onChange: this.pageChange2
            },
            columns: [
                {
                    title: '用户',
                    dataIndex: 'customerNumber'
                },
                {
                    title: '标题',
                    dataIndex: 'title'
                },
                {
                    title: '反馈内容',
                    dataIndex: 'content'
                },
                {
                    title: '反馈时间',
                    dataIndex: 'createdDate',
                    width: '10%',
                    render: (text, record) => {
                        return moment(Number(text)).format('YYYY-MM-DD HH:mm:ss')
                    }
                },
                {
                    title: '联系电话',
                    dataIndex: 'phone',
                    width: '10%'
                },
                {
                    title: '邮箱地址',
                    dataIndex: 'email',
                    width: '10%'
                },
                {
                    title: '回复信息',
                    dataIndex: 'reply',
                    render: (text, record) => (record.edit ?
                        <Input value={text} onChange={(e) => {
                            this.changeInput(e, record, 'reply')
                        }}/> : text)
                },
                {
                    title: '操作',
                    width: '5%',
                    render: (text, record, index) => {
                        if (record.edit) {
                            return (
                                button_limits_end.survey_list_04 && <div>
                                    <Button type="primary"
                                            onClick={() => {
                                                this.save(record)
                                            }}
                                    >保存
                                    </Button></div>
                            )
                        } else {
                            return (button_limits_end.survey_list_04 && <div>
                                <Button
                                    onClick={() => {
                                        this.edit(record)
                                    }}
                                >修改</Button>
                            </div>)
                        }
                    }
                }
            ],
            rows: rows2
        };

        const CollectionCreateForm = Form.create()(
            (props) => {
                const {visible, onCancel, onCreate, form} = props;
                const {getFieldDecorator} = form;
                const regexPhone = /^(\+?86)?(1[3-9]\d{9})$/;
                return (
                    <Modal
                        visible={visible}
                        title="反馈问题"
                        okText="提交"
                        onCancel={onCancel}
                        onOk={onCreate}
                        maskClosable={false}
                    >
                        <Form layout="vertical">
                            <FormItem label="标题">
                                {getFieldDecorator('title', {
                                    rules: [{required: true, message: '标题不能为空'}],
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="反馈内容">
                                {getFieldDecorator('content', {rules: [{max: 1000, message: '长度不能超过1000'}]})(
                                    <Input type="textarea" rows={4}/>)}
                            </FormItem>
                            <FormItem label="联系电话">
                                {getFieldDecorator('phone', {
                                    rules: [{
                                        pattern: regexPhone,
                                        message: '不是有效的联系电话',
                                    }]
                                })(
                                    <Input/>
                                )}
                            </FormItem>
                            <FormItem label="邮箱地址">
                                {getFieldDecorator('email', {rules: [{type: 'email', message: '不是有效的邮箱地址'}]})(
                                    <Input/>
                                )}
                            </FormItem>

                        </Form>
                    </Modal>
                );
            }
        );
        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        {button_limits_end.survey_list_01 &&
                            <Button icon="plus" onClick={this.goView.bind(this, '/survey/add')}>新增</Button>}
                        {button_limits_end.survey_list_02 &&
                            <Button icon="filter" onClick={this.visibleChange}>筛选</Button>}
                        <FilterBox {...filterBoxProps}/>
                        {button_limits_end.survey_list_03 &&
                            <Button icon="plus" onClick={this.showModal}>新增</Button>}
                        <CollectionCreateForm
                            ref={this.saveFormRef}
                            visible={this.state.visible}
                            onCancel={this.handleCancel}
                            onCreate={this.handleCreate}
                        />
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <TableView {...tableViewProps2} />
                </div>
            </div>
        )
    }
};
export default withRouter(SurveyList);




// WEBPACK FOOTER //
// ./src/routes/survey/list.js